import React from 'react'

const Heading = (props) => {
    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="center_heading">
                        <h2>{props.heading}</h2>
                        <p  style={{margin: "10px",padding: "8px 12px",fontSize: "16px",color: "#555",lineHeight: "1.5",borderRadius: "4px",backgroundColor: "white",
  }}
>
  {props.para}
</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Heading
